import React from "react";
import { LinkType } from "./Navbar";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { handleLogout } from "../../utils/data";
import { IoIosLogOut } from "react-icons/io";
import { navLinks } from "../../constants/data";

interface MobileNavbarProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const MobileNavbar: React.FC<MobileNavbarProps> = ({ open, setOpen }) => {
    const { t, i18n } = useTranslation();
    const { user } = useSelector((state: RootState) => state.user);

    const isRTL = i18n.language === "ar";

    return (
        <>
            {/* Drawer */}
            <div
                className={`fixed top-0 ${isRTL ? "right-0" : "left-0"
                    } h-full w-72 bg-white shadow-xl transform transition-transform duration-300 z-50 flex flex-col justify-between ${open ? "translate-x-0" : isRTL ? "translate-x-full" : "-translate-x-full"
                    }`}
            >
                <div className="p-5">
                    <h2 className="text-lg text-primary  mb-6">{t("menu")}</h2>
                    <ul className="flex flex-col gap-4 text-lg">
                        {navLinks.map((pageLink: LinkType, index: number) => (
                            <li
                                key={index}
                                className="cursor-pointer text-textSecond text-base hover:text-primary transition"
                            >
                                <Link to={pageLink.path} className="w-full" onClick={()=>setOpen(false)}>
                                    {i18n.language === "ar"
                                        ? pageLink.name_ar
                                        : pageLink.name_en}
                                </Link>
                            </li>
                        ))}
                    </ul>
                    {user && <p
                        className="cursor-pointer pt-4 text-textSecond text-base hover:text-primary transition"
                    >
                        <Link to={"/favorite"} className="w-full">
                            {t("favorite")}
                        </Link>
                    </p>}
                </div>

                <div className="p-5 border-t">
                    {!user ? (
                        <div className="flex flex-col gap-3">
                            <Link
                                to="auth/register"
                                className="text-secondry border border-secondry text-center py-2 rounded-lg"
                                onClick={() => setOpen(false)}
                            >
                                {t("signup")}
                            </Link>
                            <Link
                                to="auth/login"
                                className="block text-white py-2 text-center rounded-lg transition-all bg-secondry duration-300"
                                onClick={() => setOpen(false)}
                            >
                                {t("login")}
                            </Link>
                        </div>
                    ) : (
                        <button
                            onClick={() => {
                                handleLogout();
                                setOpen(false);
                            }}
                            className="flex items-center gap-3 text-white px-4 py-3 rounded-lg transition-all duration-300 shadow-md bg-gradient-to-tr from-red-700 to-red-500 hover:opacity-90"
                        >
                            <IoIosLogOut className="text-xl" />
                            <span>{t("logout")}</span>
                        </button>
                    )}
                </div>
            </div>

            {/* Overlay */}
            {open && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-40 z-40"
                    onClick={() => setOpen(false)}
                ></div>
            )}
        </>
    );
};

export default MobileNavbar;
